import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class CreateRecommendationLink extends Component {
  state = {};
  render() {
    return (
      <div className="category url_request">
        <div
          className="category_input_row max_width_500"
          style={{ width: "calc(100% - 16px)", marginRight: "8px" }}
        >
          <input
            type="text"
            className="category_name_input"
            style={{
              width: "100%",
              backgroundColor: "#f8f9fa",
              borderRadius: "10px",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
            value={this.props.url}
            placeholder={strings.url_optionnal}
            onChange={this.handleChangeURL}
            autoCorrect="off"
            autoCapitalize="off"
          />
        </div>
      </div>
    );
  }

  handleChangeURL = event => {
    this.props.handleChangeURL(event.target.value);
  };
}

export default CreateRecommendationLink;



// WEBPACK FOOTER //
// ./src/components/create_recommendation/create_recommendation_link.jsx